class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

 findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
      currentcart: newCart.items
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}

async function addToCartOng(idvariant, quantitypar=1){
  if(parseInt(window.NATULIM.REWARDS.rewardsData.donatedUnits) >0 ){
    quantitypar=parseInt(window.NATULIM.REWARDS.rewardsData.donatedUnits);
  }
  let dataadvar="";
  const cartDrawer = document.querySelector('cart-drawer');
  const fixedCart = document.querySelector('fixed-cart');
  const items = [];
  try {
    const cartSections = cartDrawer?.getSectionsToRender().map((section) => section.id) || [];
    items.push({
        id: 49760262357331,
        quantity: quantitypar
    })
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, 'sections': cartSections, 'sections_url':window.location.pathname})
    })
  
    dataadvar = await response.json();
  }catch (error) {
      console.error('Error fetching data:', error);
      //contentDiv.innerHTML = 'Failed to load data.';
  }finally {
    if (cartDrawer) {
        cartDrawer.renderContentsNoOpen(dataadvar);
        fixedCart?.renderContents(dataadvar);
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    }
  }
}

async function removeToCartOng(lineex){
  let dataadvar="";
  const cartDrawer = document.querySelector('cart-drawer');
  const items = [];
  try {
    const cartSections = cartDrawer?.getSectionsToRender().map((section) => section.id) || [];

    const line=lineex;
    const quantity=0;
    const body = JSON.stringify({
      line,
      quantity,
      sections:  cartSections,
      sections_url: window.location.pathname,
    });

    const responsechange = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    dataadvar = await responsechange.json();
  }catch (error) {
      console.error('Error fetching data:', error);
      //contentDiv.innerHTML = 'Failed to load data.';
  }finally {
    if (cartDrawer) {
        cartDrawer.renderContentsNoOpen(dataadvar);
        //this.fixedCart?.renderContents(dataadvar);
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    }
  }
}

async function updateQuantityCartOng(quantity){
  console.log("actualizar");
  /*
  let dataadvar="";
  const cartDrawer = document.querySelector('cart-drawer');
  const items = [];
  try {
    const cartSections = cartDrawer?.getSectionsToRender().map((section) => section.id) || [];

    const line=lineex;
    const quantity=0;
    const body = JSON.stringify({
      line,
      quantity,
      sections:  cartSections,
      sections_url: window.location.pathname,
    });

    const responsechange = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    dataadvar = await responsechange.json();
  }catch (error) {
      console.error('Error fetching data:', error);
      //contentDiv.innerHTML = 'Failed to load data.';
  }finally {
    if (cartDrawer) {
        cartDrawer.renderContentsNoOpen(dataadvar);
        //this.fixedCart?.renderContents(dataadvar);
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    }
  }
  */
}

document.addEventListener('DOMContentLoaded', ()=>{

  const productsCards = document.querySelectorAll('#ProductGridContainer .grid__item .card__inner');
  productsCards.forEach(card=>{
    card.addEventListener('click', evt=>{
      let openerModal=card.nextElementSibling.querySelector("modal-opener button");
      console.log(openerModal);
      openerModal.click();
    });
  });
  
  if(Boolean(window.NATULIM?.REWARDS?.SETTINGS?.isActive)){
console.log('window.giftProducts');
  class CartSelectVariants extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartfixed = document.querySelector('fixed-cart');
      this.selectvariant = this.querySelector('select');
      this.selectvariant.addEventListener('change', this.changeVariantInCart.bind(this));
      /*this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.dataset.index, 0);
      });*/
    }

    //changeVariantInCart(lineItemIndex, newVariantId, quantity) {
    async changeVariantInCart(evt) {
      console.log(evt);
      let lineItemIndex = this.selectvariant.dataset.index;
      let newVariantId = this.selectvariant.value;
      let quantity = parseInt(window.NATULIM.REWARDS.rewardsData.donatedUnits);

      this.selectvariant.disabled = true;
      try {
        // First fetch Add new item
        const response1 = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: newVariantId, // New variant ID
                quantity: quantity // Quantity to add
              }),
          });
        if (!response1.ok) {
            throw new Error('Error Add Product');
        }
        const dataAdded = await response1.json();
        console.log('Added new variant:', dataAdded);
        lineItemIndex++;
        let gResp=0;
        let parsedState=0;
        const cartSections = this.cartDrawer?.getSectionsToRender().map((section) => section.id) || [];
        const body = JSON.stringify({
          line:lineItemIndex,
          quantity:0,
          sections: cartSections,
          sections_url: window.location.pathname,
        });
        /*const response2 = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          }).then((state) => {
            gResp=state;
            parsedState = JSON.parse(state);
          });

          this.cartDrawer.renderContentsNoOpen(parsedState);
          this.cartfixed.renderItems(gResp);
        */
        const response2 = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        if (!response2.ok) {
          throw new Error('Error Delete Item');
        }
        const dataChanged = await response2.json();
        console.log('Removed item:', dataChanged);
        // Optionally, update the cart display here
        this.cartDrawer.renderContentsNoOpen(dataChanged);
        this.cartfixed.renderContents(dataChanged);
      } catch (error) {
        console.error('Error:', error);
      } finally {
          this.selectvariant.disabled = true;
      }
    }
  }
  
  customElements.define('cart-select-variants', CartSelectVariants);
  
  console.log('window.giftProducts');
  console.log(window.ONGproductId);

  console.log(window.NATULIM.REWARDS.rewardsData);

  
    const myCartWatcher = new CartWatcher;
    myCartWatcher.init();
    window.addEventListener("cart_changed", e => {
      if(e.detail.currentcart.length>0){
        let existproductong=false;
        /*window.giftProducts.forEach(giftitem=>{
          let searchpr = e.detail.currentcart.find(pr => pr.product_id == 9594357973331);
          if(searchpr) existproductong=true;
          console.log("searchpr");
          console.log(searchpr);
        });*/
  
        /*let searchpr = e.detail.currentcart.find(pr => pr.product_id == 9594357973331);
        if(searchpr) existproductong=true;
        console.log("searchpr");
        console.log(searchpr);
        
        if(existproductong){
          console.log("ya existe el  produccto");
          updateQuantityCartOng(parseInt(window.NATULIM.REWARDS.rewardsData.donatedUnits));
        }else{
          console.log("NO existe el  produccto");
          addToCartOng(49760262357331,1);
        }*/
        
      }else{
        //removeToCartOng(lineex);
      }
    });
  }
});
